import { RootReducerState } from './../ngrx.imports';
import { createSelector } from '@ngrx/store';
import { TerritoryMapStoreState } from './territoryMapData.state';

export const getTerritoryMapState = (state: RootReducerState) => state.territoryMap;


//Selectors
export const getTerriotyMapAllData = (state: TerritoryMapStoreState) => state.territoryMap;
export const selectorTerritoryMapAllData = createSelector(getTerritoryMapState,getTerriotyMapAllData);
